import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import * as React from 'react';
import styles from './index.module.scss';
export class CSATChromePreview extends React.PureComponent {
    render() {
        const { className, children } = this.props;
        const rootClassName = classnames({
            [styles.root]: true,
            className,
        });
        return (_jsx("div", Object.assign({ className: rootClassName }, { children: _jsx("div", Object.assign({ className: styles.preview }, { children: children })) })));
    }
}
